import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICollaboratorReport } from '../data/collaborator-report';
import { statusLabel } from '../services/collaborator-report.service';

@Component({
  selector: 'app-list-collaborator-report',
  templateUrl: './list-collaborator-report.component.html',
  styleUrls: ['./list-collaborator-report.component.scss']
})
export class ListCollaboratorReportComponent {
  // Reaproveita a regra do service para nao duplicar "1 = Admitido" no template.
  readonly statusLabel = statusLabel;

  @Input() collaboratorReports: ICollaboratorReport[] = [];
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() mudouPagina = new EventEmitter<number>();
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };
}
